import React from "react";
import { Button } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const AddNotesCell = ({ claim, setSelectedClaimNotes }) => {
  const { t } = useTranslation();

  return (
    <td>
      <Button
        variant="outline-primary"
        size="sm"
        className="d-flex align-items-center gap-1 custom-addnotes-btn"
        onClick={() => setSelectedClaimNotes(claim._id)}
      >
        <FontAwesomeIcon icon={faStickyNote} />
        {t("addNotes")}
      </Button>
    </td>
  );
};

export default AddNotesCell;
